import { Component } from '@angular/core';

interface Regime {
  id: number;
  title: string;
  desc: string;
  link: string;
  img: string;
}

@Component({
  selector: 'app-operations',
  templateUrl: './operations.component.html',
  styleUrls: ['./operations.component.scss'] 
})
export class OperationsComponent {
  regimes: Regime[] = [
    {
      id: 1,
      title: 'المناطق الحرة',
      desc: 'تعد المناطق الحرة في مصر نمطا استثمارياً متميزاً كونها أحد أنظمة الاستثمار الخاضعة لاحكام قانون الاستثمار رقم 72 لسنة 2017 ولائحته التنفيذية والذي تشرف على تطبيقه الهيئة العامة للاستثمار والمناطق الحرة.',
      link: 'https://www.gafi.gov.eg/Arabic/StartaBusiness/InvestmentZones/Pages/FreeZones.aspx',
      img: '../../../assets/yyy.png',
    },
    {
      id: 2,
      title: 'الاستثمار الداخلي',
      desc: 'يخضع الاستثمار الداخلي لقانون حوافز وضمانات الاستثمار رقم 8 لعام 1997 وقانون الشركات رقم 159 لعام 1981 وتعديلاتهما. وتعمل الهيئة العامة للاستثمار والمناطق الحرة كمراقب ومنظم رسمي لكافة عمليات إنشاء الشركات والتراخيص الخاضعة لكلا القانونين.',
      link: 'https://www.gafi.gov.eg/Arabic/StartaBusiness/InvestmentZones/Pages/Inland.aspx',
      img: '../../../assets/yyy.png',
    },
    {
      id: 3,
      title: 'المناطق الاستثمارية',
      desc: 'هي مناطق جغرافية محددة المساحة والحدود تخصص لإقامة نشاط معين أو أكثر من الأنشطة الاستثمارية المتخصصة وغيرها من الأنشطة المكملة لها. ويقوم على تنميتها ووضع بنيتها الأساسية مطور لتلك المنطقة.',
      link: 'https://www.gafi.gov.eg/Arabic/StartaBusiness/InvestmentZones/Pages/Investment-Zone.aspx',
      img: '../../../assets/yyy.png',
    },
  ];

  selectedRegime: Regime = this.regimes[0];

  selectRegime(regime: Regime) {
    this.selectedRegime = regime;
  }
}
